import React from 'react';
import { Box, Typography } from '@mui/material';
import { ImageWithFallback } from '../figma/ImageWithFallback';

export function HeroSection() {
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: { xs: 300, md: 360 },
        bgcolor: '#002b49',
        overflow: 'hidden',
        mt: { xs: 10, md: 10 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // leave room for the search card that overlaps the bottom of the hero
        pb: { xs: 9, md: 12 },
        pt: { xs: 4, md: 5 },
      }}
    >
      {/* Same hero image as before */}
      <ImageWithFallback
        src="https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600&h=400&fit=crop"
        alt="Hero background"
        className="absolute inset-0 w-full h-full object-cover"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />

      {/* Deep-blue gradient overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(0,43,73,0.45) 0%, rgba(0,43,73,0.85) 100%)',
        }}
      />

      <Box
        sx={{
          position: 'relative',
          maxWidth: 1400,
          mx: 'auto',
          px: { xs: 2, sm: 3, lg: 4 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          color: 'white',
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          sx={{
            mb: 1.5,
            maxWidth: 720,
            fontWeight: 800,
            letterSpacing: '-0.02em',
            fontSize: { xs: '2rem', sm: '3rem' },
            lineHeight: 1.1,
            textShadow: '0 2px 8px rgba(0,0,0,0.3)',
          }}
        >
          Discover Your Perfect Stay
        </Typography>
        <Typography
          sx={{
            maxWidth: 560,
            color: '#dbeafe',
            fontWeight: 500,
            fontSize: { xs: '0.8rem', sm: '0.95rem' },
          }}
        >
          From luxury hotels to cozy homestays, find unique accommodations for your next adventure
        </Typography>
      </Box>
    </Box>
  );
}
